export const FETCH_FAIR_GAMES_BEGIN = 'fair:FETCH_FAIR_GAMES_BEGIN'
export const FETCH_FAIR_GAMES_FAIL = 'fair:FETCH_FAIR_GAMES_FAIL'
export const FETCH_FAIR_GAMES_SUCCESS = 'fair:FETCH_FAIR_GAMES_SUCCESS'
export const FETCH_VERIFIED_GAME_BEGIN = 'fair:FETCH_VERIFIED_GAME_BEGIN'
export const FETCH_VERIFIED_GAME_FAIL = 'fair:FETCH_VERIFIED_GAME_FAIL'
export const FETCH_VERIFIED_GAME_SUCCESS = 'fair:FETCH_VERIFIED_GAME_SUCCESS'
